import React from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { usePerdasSuprimentos } from "./perdasData";

// ---------------------- Componente ----------------------
// ---------------------- Componente ----------------------
const SuprimentosPerdas: React.FC = () => {
  const headers = [
    "Responsável",
    "Código",
    "Tipo", // 👈 NOVO (entre Código e Nome)
    "Nome do Produto",
    "Custo Unitário",
    "Quantidade",
    "Motivo",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = usePerdasSuprimentos();

  const columnWidths = [
    "140px", // Responsável
    "70px", // Código
    "80px", // Tipo  👈 NOVO
    "270px", // Nome
    "100px", // Custo
    "30px", // Quantidade
    "150px", // Motivo
    "80px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons title="Suprimentos - Perdas" />
      <Table headers={headers} rows={rows} columnWidths={columnWidths} />
    </div>
  );
};

export default SuprimentosPerdas;
